import { defineMessages } from 'react-intl';

export default defineMessages({
  emptyMsg: 'No surveys',
  title: 'Title',
  viewCount: 'Views',
  viewCountTooltip: 'Last 30 days',
  responseCount: 'Responses',
  responseCountTooltip: 'Last 30 days',
  firstResponse: 'First response',
  latestResponse: 'Latest response',
  none: 'None',
  status: 'Status',
  noWebsite: '(No website)',
  distributionStart: 'From {date}',
  distributionEnd: 'To {date}',

  newSurvey: 'New survey',
});
